import Util from '@/service/Util'
import http from '../http'

export default {
  /*
  * PackageType endpoints
  */
  listPackageTypes(req) {
    return http.get('/masterdata/v1/packagetypes', { params: req })
  },

  deletePackageType(id) {
    return http({
      method: 'delete',
      url: `/masterdata/v1/packagetypes/${id}`,
      data: {
        id
      }
    })
  },

  undeletePackageType(id) {
    return http({
      method: 'delete',
      url: `/masterdata/v1/packagetypes/${id}/deleted`,
      data: {
        id
      }
    })
  },

  readPackageType(id) {
    return http({
      method: 'GET',
      url: `/masterdata/v1/packagetypes/${id}`,
      roles: ['ROLE_PACKAGE_TYPE_MANAGER']
    })
  },

  addPackageType(data) {
    return http.post('compass-ws-rest/packagetypes', data)
  },

  updatePackageType(id, data) {
    return http.put(`compass-ws-rest/packagetypes/${id}`, data)
  },

  /*
  * Product endpoints
  */
  listProducts(params) {
    return http({
      method: 'GET',
      url: '/masterdata/v1/products',
      params,
      roles: ['ROLE_PRODUCT_READER', 'ROLE_PRODUCT_MANAGER']
    })
  },

  undeleteProduct(id) {
    return http({
      method: 'delete',
      url: `/masterdata/v1/products/${id}/deleted`,
      data: {
        id
      }
    })
  },

  getProduct(id) {
    return http({
      method: 'GET',
      url: `/masterdata/v1/products/${id}`,
      roles: ['ROLE_PRODUCT_MANAGER', 'ROLE_PRODUCT_READER']
    })
  },

  updateProduct(id, data) {
    return http({
      method: 'PUT',
      url: `/masterdata/v1/products/${id}`,
      data,
      roles: ['ROLE_PRODUCT_MANAGER'],
      headers: { 'X-RequestId': Util.createUniqueXRequestId() },
    })
  },

  createProduct(data) {
    return http({
      method: 'POST',
      url: '/masterdata/v1/products',
      data,
      roles: ['ROLE_PRODUCT_MANAGER'],
      headers: { 'X-RequestId': Util.createUniqueXRequestId() },
    })
  },

  deleteProduct(id) {
    return http({ method: 'DELETE', url: `/kcengine-ws-rest/products/${id}`, data: { productId: id } })
  },
}



// WEBPACK FOOTER //
// ./src/service/apis/Masterdata.js